<template lang="pug">
	.v-catalog-sale.catalog
		//v-loader(:loading="loading")
		.container
			template(v-if="!catalog")
				.catalog__placeholder
			template(v-if="catalog")
				.catalog__layout
					.catalog__layout-aside
						button.catalog__aside-close(type="button" @click="closeAside")
							v-svg-icon.catalog__aside-close-icon(icon="close")
						.catalog__layout-aside-container
							.catalog__layout-aside-container-inner
								.catalog__filter.flc(v-if="catalog.links || catalog.filters")
									v-filter(ref="filter"
										:filters="catalog.filters"
										:links="catalog.link"
										:variables="catalog.variables"
										@filter-changed="filterChanged"
										@filter-updated="filterUpdated"
										@request-reset="resetFilter"
										@request-reset-all="resetAllFilters")
							.catalog__layout-aside-actions
								transition(name="fade")
									button.catalog__layout-aside-btn.btn.btn--primary(v-if="catalog?.result?.href"
										type="button"
										@click="submitFilters") {{ catalog?.result?.text || 'Поиск' }}
								button.catalog__layout-aside-btn.catalog__layout-aside-btn--secondary.btn.btn--primary(v-if="!catalog?.variables?.hideReset" @click="resetAllFilters") {{ catalog?.variables?.reset || 'Reset' }}

					.catalog__layout-main
						.catalog__form(v-if="catalog.type === 'list'" )
							.catalog__top-nav.flc
								.catalog__top-nav-grid
									.catalog__top-nav-cell--left
										.catalog__top-nav-cell.catalog__top-nav-cell--aside-toggle(v-if="catalog.filters || catalog.links")
											button.catalog__aside-toggle(type="button" @click="openAside")
												v-svg-icon.catalog__aside-toggle-icon(icon="filter")
							v-filter(:filters="catalog.filtersPage" @filter-changed="filterPageChanged")
						template(v-else)
							.catalog__top-nav.flc(v-if="catalog.sort && state.view !== 'map' || catalog.view && catalog.view.options && catalog.view.options.length && state.view !== 'map'")
								.catalog__top-nav-grid
									.catalog__top-nav-cell--left
										.catalog__top-nav-cell.catalog__top-nav-cell--total(v-if="catalog.items && catalog.page")
											| {{ `${catalog.page.count} ${catalog.variables.object}` }}
										//.catalog__top-nav-cell.catalog__top-nav-cell--active-filters(v-if="changedFilters && changedFilters.length")
										//	v-filter-active-items(:filters="changedFilters" @reset-filter="resetFilter")
										.catalog__top-nav-cell.catalog__top-nav-cell--aside-toggle(v-if="catalog.filters || catalog.links")
											button.catalog__aside-toggle(type="button" @click="openAside")
												v-svg-icon.catalog__aside-toggle-icon(icon="filter")
										.catalog__top-nav-cell.catalog__top-nav-cell--select(v-if="catalog.sort && !isSm")
											v-field(:field="{type: 'select', options: catalog.sort.options}"
												v-model="state.sort"
												@update:model-value="requestDataLoad")
									.catalog__top-nav-cell--right
										.catalog__top-nav-cell.catalog__top-nav-cell--select(v-if="catalog.sort && isSm")
											v-field(:field="{type: 'select', options: catalog.sort.options}"
												v-model="state.sort"
												@update:model-value="requestDataLoad")
										.catalog__top-nav-cell.catalog__top-nav-cell--view(v-if="catalog.view")
											v-field(:field="{type: 'view-picker', options: catalog.view.options}"
												v-model="state.view" @update:model-value="changeView")
												.catalog__loader(v-if="loadingView") Загрузка...
							.catalog__list.flc
								transition(name="fade" mode="out-in")
									.catalog__list-message.flc(v-if="!catalog.items || !catalog.items.length && catalog.message")
										.catalog__list-message-title.h3.flc(v-if="catalog.message.title" ) {{ catalog.message.title }}
										.catalog__list-message-body.flc(v-if="catalog.message.body" ) {{ catalog.message.body }}
										//.catalog__list-message-actions.flc
										//	.catalog__list-message-actions-grid
										//		.catalog__list-message-action(v-if="changedFilters && changedFilters.length")
										//			button.btn(type="button" @click="resetAllFilters") Очистить фильтр
										//		.catalog__list-message-action
										//			a.btn(href="/") На главную страницу
									//v-product-grid(v-else-if="state.view === 'grid' && catalog.type === 'products'"
									//	:items="catalog.items"
									//	quick-view)
									v-product-list(v-else-if="state.view === 'list' && catalog.type === 'products'"
										:items="catalog.items"
										quick-view)
									v-article-grid(v-else-if="catalog.type === 'articles'"
										:items="catalog.items")
									.catalog__map-filter(v-else-if="state.view === 'map'")
										.map-filter__nav
											//.map-filter__total(v-if="catalog.items && catalog.page")
											//	| {{ `${catalog.page.count} ${pluralize(catalog.page.count, catalog.variables.object, ['', 'а', 'ов'])}` }}
											.map-filter__view(v-if="catalog.view")
												v-field(:field="{type: 'view-picker', options: catalog.view.options}"
													v-model="state.view")
										v-map-google.map-filter__map(
											:type="catalog.type"
											:initParams="catalog.map"
											:items="catalog.itemsOnMap"
											:variables="catalog.variables"
											@drawing-area="drawingArea")
							.catalog__nav.flc(v-if="state.view !== 'map'" )
								v-page-nav(:page="catalog.page" :variables="catalog.variables" :limits="catalog.limits" @navigate="navigate")
</template>

<script>
import axios from 'axios';
import controller from '../scripts/controller/controller.js';
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
export default {
	mixins: [
		sourceMixin,
		formattingMixin,
		isMobMixin
	],

	data() {
		return {
			catalog: null,
			state: {
				page: null,
				sort: null,
				view: null,
				filter: null
			},
			changedFilters: null,
			asideOpen: false,
			loadingView: false,
		};
	},

	mounted() {
		// Штампуем текущую страницу (offset) в URL прямо перед уходом со страницы
		// (клик по объявлению и т.п.) — гарантированно последним действием, чтобы
		// браузерный «Назад» вернул на ту же страницу списка (сервер отрендерит её
		// по offset из URL). Это надёжнее, чем править URL во время пагинации, т.к.
		// не может быть перезатёрто поздними обновлениями состояния/истории.
		window.addEventListener('pagehide', this.syncPageUrl);
	},

	unmounted() {
		window.removeEventListener('pagehide', this.syncPageUrl);
	},

	methods: {
		submitFilters() {
			// Do not rely on the debounced filterChanged event: a user may click
			// Search immediately after choosing an option while its dropdown is open.
			const filterValue = this.$refs.filter
				? this.$refs.filter.flushPendingChange(false)
				: this.state.filter;
			this.state.filter = filterValue;

			this.dataLoad({
				url: this.catalog.remote,
				data: {
					page: this.state.page,
					sort: this.state.sort,
					filter: filterValue,
					mapFilter: this.state.mapFilter,
					action: 'filterChanged'
				},
				onSuccess: (data) => {
					const href = data?.result?.href || data?.remoteSet;
					if (href) {
						window.location.href = href;
					}
				}
			});
		},

		async loadMapPoints() {

			if (this.catalog.itemsOnMap.length === 0)
			{
				const options = {
					url: this.catalog.remote,
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: {getMapPoints: 'y', bxajaxid: this.localBxajaxid}
				};
				axios(options)
					.then(response => {
						let data = response.data;
						if ((typeof (data.encoded) !== 'undefined')) {
							data = JSON.parse(atob(data.encoded));
						}
						this.catalog.itemsOnMap = data.itemsOnMap

						this.$emit('update:model-value', this.localValue);
					});
			}
		},
		dataSet(data, options = {}) {
			console.log('Component dataSet');
			console.log(data);
			console.log(this.catalog)
			if (data.filterUpdate && data.filters?.length)
			{
				this.catalog.filters = data.filters;
				this.catalog.remote = data.remote;
				this.catalog.result = data.result;
				return;
			}

			if (options.append && this.catalog && this.catalog.items)
			{
				let oldItems = this.catalog.items;
				this.catalog = data;
				this.catalog.items = oldItems.concat(this.catalog.items);
			} else
			{
				if (!this.remoteSet && !this.catalog && data.remoteSet)
				{
					this.remoteSet = data.remoteSet;
				}
				this.catalog = data;
			}
			if (this.remoteSet && this.catalog.remoteSet && this.remoteSet !== this.catalog.remoteSet)
			{
				history.pushState(this.catalog.remoteSet, this.catalog.seo.title, this.catalog.remoteSet);
				this.remoteSet = this.catalog.remoteSet;
				if (this.catalog.seo)
				{
					if (document.title !== this.catalog.seo.title)
					{
						document.title = this.catalog.seo.title;
					}
					if (!document.querySelector('meta[name="description"]'))
					{
						let meta = document.createElement('meta');
						meta.name = 'description';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (!document.querySelector('meta[name="keywords"]'))
					{
						let meta = document.createElement('meta');
						meta.name = 'keywords';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (this.catalog.seo.robots && document.querySelector('meta[name="robots"]'))
					{
						document.querySelector('meta[name="robots"]').setAttribute('content', this.catalog.seo.robots);
					} else if (this.catalog.seo.robots && !document.querySelector('meta[name="robots"]'))
					{
						let meta = document.createElement('meta');
						meta.name = 'robots';
						document.getElementsByTagName('head')[0].appendChild(meta);
						document.querySelector('meta[name="robots"]').setAttribute('content', this.catalog.seo.robots);
					} else if (!this.catalog.seo.robots && document.querySelector('meta[name="robots"]'))
					{
						document.querySelector('meta[name="robots"]').remove();
					}
					if (this.catalog.seo.canonical && document.querySelector('link[rel="canonical"]'))
					{
						document.querySelector('link[rel="canonical"]').setAttribute('href', this.catalog.seo.canonical);
					} else if (this.catalog.seo.canonical && !document.querySelector('link[rel="canonical"]'))
					{
						let meta = document.createElement('link');
						meta.rel = 'canonical';
						meta.href = this.catalog.seo.canonical;
						document.getElementsByTagName('head')[0].appendChild(meta);
					} else if (!this.catalog.seo.canonical && document.querySelector('link[rel="canonical"]'))
					{
						document.querySelector('link[rel="canonical"]').remove();
					}
					document.querySelector('meta[name="description"]').setAttribute('content', this.catalog.seo.description);
					document.querySelector('meta[name="keywords"]').setAttribute('content', this.catalog.seo.keywords);
					if (document.querySelector('#bx-panel'))
					{
						document.querySelector('#bx-panel').remove();
					}
					this.$store.commit('breadcrumbs/set', this.catalog.seo.chain);
				}
			}
			this.state.sort = this.catalog.sort ? this.catalog.sort.value : null;
			this.state.page = this.catalog.page;
			this.state.view = this.state.view || this.catalog.view && this.catalog.view.value || 'grid';
		},

		navigate(page) {
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
			if (!page.append) this.syncPageUrl();
		},

		// Синхронизируем номер страницы (offset) в URL, чтобы при возврате из карточки
		// объявления (браузерный «Назад») сервер отрендерил ту же страницу списка, а не
		// первую. Бэкенд читает page[offset]/page[limit] из запроса и рендерит нужную
		// страницу (SSR), нативное восстановление скролла подводит к тому же объявлению.
		syncPageUrl() {
			try {
				if (window.location.pathname.indexOf('/local/') > -1) return;
				const offset = parseInt(this.state.page && this.state.page.offset) || 0;
				const limit = parseInt(this.state.page && this.state.page.limit) || 0;
				const params = (window.location.search || '').replace(/^\?/, '')
					.split('&').filter(p => p && !/^page(\[|%5B)/i.test(p));
				if (offset > 0) {
					params.push('page[offset]=' + offset);
					params.push('page[limit]=' + limit);
				}
				const search = params.length ? '?' + params.join('&') : '';
				window.history.replaceState(window.history.state, document.title,
					window.location.pathname + search + window.location.hash);
			} catch (e) {}
		},

		sortChanged() {
			this.state.page.offset = 0;
			this.requestDataLoad();
		},

		filterUpdated(filterValue, changedFilters) {
			this.state.filter = filterValue;
			this.changedFilters = changedFilters;
			// update url except markup pages
			if (window.location.pathname.indexOf('/local/') < 0)
			{
				window.history.replaceState(null, null, this.catalog.remote);
			}
		},

		filterChanged(filterValue) {
			this.state.filter = filterValue;
			this.requestDataLoad({action: 'filterChanged'});
		},

		filterPageChanged(filterValue) {
			this.state.filter = filterValue;
			this.requestDataLoad({action: null});
		},

		drawingArea(path) {
			this.dataLoad({
				url: this.catalog.remote,
				delay: true,
				data: {
					filter: this.state.filter,
					mapFilter: path,
					action: 'drawing'
				}
			});
		},

		requestDataLoad(dataSetOptions) {
			const {action = null} = dataSetOptions;
			this.dataLoad({
				url: this.catalog.remote,
				delay: true,
				data: {
					page: this.state.page,
					sort: this.state.sort,
					filter: this.state.filter,
					mapFilter: this.state.mapFilter,
					action
				}
			}, dataSetOptions);
		},

		async changeView(view) {
			this.state.view = view;
			this.loadingView = true; // Устанавливаем состояние загрузки
			if (view === 'map' && this.catalog.itemsOnMap.length === 0)
			{
				await this.loadMapPoints();
			}
		},

		// sendData() {
		// 	this.requestDataLoad();
		// },

		openAside() {
			controller.openCatalogAside();
		},

		closeAside() {
			controller.closeCatalogAside();
		},

		resetFilter(e) {
			this.$refs.filter.resetFilter(e);
		},

		resetAllFilters() {
			this.dataLoad({
				url: this.catalog.remote,
				delay: true,
				data: {
					action: 'filterClear'
				}
			},);
			// this.$refs.filter.resetAll(e);
		},

		updateLocalState() {

		}

	},

	watch: {
		state: {
			handler(newValue, oldValue) {
				if (newValue.view === 'map' && this.isXs)
				{
					this.$nextTick(() => {
						const footer = document.querySelector('footer.page-footer')
						const breadcrambs = document.querySelector('.v-breadcrumbs')

						if (footer) footer.style.display = 'none'
						if (breadcrambs) breadcrambs.style.display = 'none'
					})
				} else
				{
					this.$nextTick(() => {
						const footer = document.querySelector('footer.page-footer')
						const breadcrambs = document.querySelector('.v-breadcrumbs')

						if (footer) footer.style.display = 'block'
						if (breadcrambs) breadcrambs.style.display = 'block'
					})
				}

			},
			deep: true
		}
	}

};
</script>
